import { EXTERNAL_PARTNERS } from '../../client/lib/constants';
import getContent from '../../client/lib/dictionaryFetcher';

let partnersInstance = null;

class Partners {
  constructor(marketplaceConnectConfig = {}) {
    if (!partnersInstance) {
      partnersInstance = {};
      EXTERNAL_PARTNERS.forEach(name => {
        const config = marketplaceConnectConfig[name] || {};
        partnersInstance[name] = {
          active: true,
          key: name,
          name: getContent('merchanthub', `apps.${name}.title`),
          description: getContent('merchanthub', `apps.${name}.description`),
          link: config.redirect_uri,
          label: getContent('merchanthub', `apps.${name}.new`),
          type: 'partner',
          terms: config.terms
        };
      });
    }
    return partnersInstance || {};
  }

  static instance() {
    return partnersInstance || {};
  }

  static init(marketplaceConnectConfig) {
    new Partners(marketplaceConnectConfig);
  }
}

export default Partners;
